import api from './client';

export interface Stats {
  totalTickets: number;
  openTickets: number;
  awaitingCustomerTickets: number;
  closedTickets: number;
  aiMessages: number;
  aiMessagesHelpful: number;
  aiMessagesUnhelpful: number;
  aiMessagesNoFeedback: number;
  verifiedAiMessages: number;
  unverifiedAiMessages: number;
}

export const statsApi = {
  get: (params: { machineId?: string; customerNip?: string; tagId?: string; integratorId?: string } = {}) =>
    api.get<Stats>('/api/admin/stats', { params }),
};
